import { action, computed, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";

class UiMeet3dActivityLog extends Model {
  /**
   * @property {number|null}
   */
  @observable uiMeet3dActivityLogId = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {number|null}
   */
  @observable seconds = null;

  /**
   * @property {Moment|null}
   */
  @observable activityDts = null;

  /**
   * Set new data to our model
   * @override
   * @param {object} data
   */
  @action
  setData(data) {
    const { activityDts, ...rest } = data;
    set(this, rest);

    this.activityDts = activityDts ? moment.unix(activityDts) : null;
  }

  @computed
  get durationDescription() {
    if (this.seconds === null) {
      return null;
    }

    if (this.seconds === 0) {
      return 0;
    }

    // This way supports seconds for up to a day minus a second
    // 23 hours 59 minutes 59 seconds or 86399 seconds
    return new Date(this.seconds * 1000).toISOString().substr(11, 8);
  }
}

export default UiMeet3dActivityLog;
